import { useQuery } from 'data-fetching-client';
import { FETCH_SPOTLIGHT_SENTIMENT_COUNT } from 'messaging-publishing-lib/Insights/queries';
const useFetchSpotlightSentimentCount = variables => {
  const {
    data: maybeData,
    loading,
    error
  } = useQuery(FETCH_SPOTLIGHT_SENTIMENT_COUNT, {
    variables
  });
  const data = maybeData ? maybeData.spotlightSentimentCount : {
    positiveSpotlightCount: 0,
    negativeSpotlightCount: 0
  };
  return {
    data,
    loading,
    error
  };
};
export default useFetchSpotlightSentimentCount;